import $ from 'jquery';
import 'slick-carousel/slick/slick.min.js';

class Blog {
  constructor(config, item) {
    if (!config || !item) throw Error('Blog config is reqired!');
    this.config = {
      url: '', // type: string;
      title: '', // type: string;
      more: true, // type: boolean; default: true;
      mode: 'default', // type: string; can be: default, grid, slick, two-column, 1+3;
      background: false, // type: boolean; default: false;
      description: true, // type: boolean; default: true;
      details: 'row', // type: string; can be: 'row', 'column';
      bigimage: false, // type: boolean; default: false;
      horizontal: false, // type: boolean; default: false;
      articlestoshow: 3, // type: number;
      banner: false, // type: string
      bannerposition: 'left', // type: string; can be: 'left', 'right';
      ...config,
    };
    this.item = item;
    // ** https://developer.mozilla.org/en-US/docs/Web/API/Intersection_Observer_API
    this.observer = new IntersectionObserver((entries) => this.onVisibilityChange(entries), { threshold: [0.25] });
    this.init();
  }

  article(json, options = {}) {
    const config = {
      ...this.config,
      ...options,
    };
    return `
      <article class="cm_article${config.bigimage ? ' --full' : ''}${config.horizontal ? ' --horizontal' : ''}">
        <figure class="cm_article__image">
          <img src="${json.image.src}" alt="${json.name}" width="${json.image.width}" height="${json.image.height}"/>
        </figure>
        <div class="cm_article__info">
          <a class="cm_article__name" href="${json.link}">${json.name}</a>
          ${config.description ? `<div class="cm_article__desc">
            ${json.description.replace(/&lt;/g, '<').replace(/&gt;/g, '>')}
          </div>` : ''}
          <div class="cm_article__details ${config.details === 'column' ? ' --column' : ''}">
            ${json.category[0] ? `<div class="cm_article__categories">
              <a class="cm_article__category" href="${json.category[0].link}" title="${json.category[0].name}">${json.category[0].name}</a>
            </div>` : ''}
            <div class="cm_article__date">${json.date.year}-${json.date.month}-${json.date.day}</div>
            <a class="cm_article__more" href="${json.link}"><i class="icon-angle-right"></i></a>
          </div>
        </div>
      </article>
    `;
  }

  articles(json) {
    const { config: { mode, articlestoshow } } = this;
    let data = '';
    let template = `
    <section class="cm_articles --${this.config.mode}${this.config.background ? ' --bg' : ''}">
      ${this.config.title ? `<div class="cm_articles__title">${this.config.title}</div>` : ''}
    `;

    if (mode === 'two-column') {
      for (let index = 0; index < json.length; index += 1) {
        if (index > articlestoshow - 1) break;
        const element = json[index];
        if (index > 0) {
          data += `<div class="col-12">${this.article(element)}</div>`;
        }
      }
      // config for the first arcticle
      const config = {
        bigimage: true,
        horizontal: false,
        details: 'row',
      };

      template += `
        <div class="row">
          <div class="col-12 col-md-8">${this.article(json[0], config)}</div>
          <div class="col-12 col-md-4">
            <div class="cm_articles__wrap row">${data}</div>
          </div>
        </div>
      `;
    } else if (mode === 'banner') {
      for (let index = 0; index < json.length; index += 1) {
        if (index > articlestoshow - 1) break;
        const element = json[index];
        data += `<div class="col-12">${this.article(element)}</div>`;
      }
      template += `
        <div class="row${(this.config.bannerposition === 'right' ? ' flex-md-row-reverse' : '')}">
          <div class="col-12 col-md-4">
            <img class="cm_articles__banner" src="${this.config.banner}">
          </div>
          <div class="col-12 col-md-8">
            <div class="cm_articles__wrap row">${data}</div>
          </div>
        </div>
      `;
    } else {
      for (let index = 0; index < json.length; index += 1) {
        if (index > articlestoshow - 1) break;
        const element = json[index];
        data += `<div class="col-12 col-md-4">${this.article(element)}</div>`;
      }
      template += `<div class="cm_articles__wrap row">${data}</div>`;
    }

    template += `
    ${this.config.more ? `
      <a class="cm_articles__more" href="${this.config.url}">
        ${window.Literals.blog.seeMore} <i class="icon-angle-right"></i>
      </a>
    ` : ''}</section>`;
    return template;
  }

  setEvents() {
    const { mode } = this.config;
    if (mode === 'slick') {
      $('.--slick > .cm_articles__wrap:not(.slick-slide)').slick({
        arrows: false,
        infinite: false,
        responsive: [
          {
            breakpoint: 979,
            settings: 'unslick',
          },
        ],
      });
    }
  }

  async sendRequest() {
    const url = `${this.config.url}?shop_xml=1&get_ajax_items=bloglist_items`;
    try {
      const res = await fetch(url);
      return (res.ok) ? res.json() : null;
    } catch (err) {
      return null;
    }
  }

  // eslint-disable-next-line class-methods-use-this
  parseData(string) {
    const [_json] = string.split('<script>').pop().split('</script>');
    const { blogitems: json } = JSON.parse(_json);
    return json;
  }

  getData() {
    this.sendRequest().then(({ bloglist_items: res }) => this.parseData(res)).then((data) => {
      const HTML = this.articles(data);
      this.item.outerHTML = HTML;
      this.setEvents();
    });
  }

  onVisibilityChange(entries) {
    if (entries[0].intersectionRatio <= 0) return;
    this.getData();
    this.observer.unobserve(this.item);
  }

  init() {
    this.observer.observe(this.item);
  }
}

export default Blog;
